import './Alignment.css';
export var horizontalAlignment = {right:'_yj6voi0-3-15-1',left:'_yj6voi1-3-15-1',center:'_yj6voi2-3-15-1'};
export var verticalAlignment = {top:'_yj6voi3-3-15-1',center:'_yj6voi4-3-15-1',bottom:'_yj6voi5-3-15-1'};